import "./LineTextLabel.scss";

const LineTextLabel = ({ text, showBorder = true }) => (
  <div
    id="line-text-label-container"
    className={`text-16-500 ${showBorder ? "with-border" : "without-border"}`}
  >
    {text}
  </div>
);

export default LineTextLabel;


// import "./LineTextLabel.scss";
// const LineTextLabel = ({ text }) => (
//   <div id="line-text-label-container" className="text-16-500">
//     {text}
//   </div>
// );
// export default LineTextLabel;
